"use client"

import { useState, useEffect } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Header from "./Common/Header"
import Footer from "./Common/Footer"
import HomePage from "./Home/HomePage"
import SignIn from "./Auth/SignIn"
import Login from "./Auth/Login"
import Details from "./Rem/Details"
import OrderTracking from "./Cart/OrderTracking"
import BakeryCatalog from "./Catalog/BakeryCatalog"
import CartPage from "./Cart/CartPage"
// Import the CartProvider
import { CartProvider } from "./Context/CartContext"
import OrderConfirmation from "./Cart/OrderConfirmation"
import PaymentPage from "./Cart/Payment"
import OrdersPage from "./Cart/OrdersPage"

// Import Policy Pages
import PrivacyPolicy from "./Policy/PrivacyPolicy"
import TermsAndConditions from "./Policy/TermsAndConditions"
import CancellationRefund from "./Policy/CancellationRefund"
import ShippingDelivery from "./Policy/ShippingDelivery"
import ContactUs from "./Policy/ContactUs"
import ScrollToTop from "./Assets/ScrollToTop"

// Wrap the entire app with CartProvider
function App() {
  
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  // Check login status on page load
  useEffect(() => {
    const token = localStorage.getItem("token")
    setIsLoggedIn(!!token) // Convert to boolean
  }, [])

  // Function to update login state
  const handleLogin = () => {
    setIsLoggedIn(true)
  }

  const handleLogout = () => {
    localStorage.removeItem("token")
    setIsLoggedIn(false)
  }

  return (
    <div>
      <CartProvider>
        <BrowserRouter>
          <Header isLoggedIn={isLoggedIn} onLogout={handleLogout} />
          <ScrollToTop/>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/signin" element={<SignIn onLogin={handleLogin} />} />
            <Route path="/login" element={<Login onLogin={handleLogin} setIsLoggedIn={setIsLoggedIn} />} />
            <Route path="/details" element={<Details />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/confirm" element={<OrderConfirmation />} />
            <Route path="/tracking" element={<OrderTracking />} />
            <Route path="/catalog" element={<BakeryCatalog />} />
            <Route path="/orders" element={<OrdersPage />} />

            {/* Policy Pages Routes */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/cancellation-refund" element={<CancellationRefund />} />
            <Route path="/shipping-delivery" element={<ShippingDelivery />} />
            <Route path="/contact-us" element={<ContactUs />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </CartProvider>
    </div>
  )
}

export default App

